import MarkdownIt from 'markdown-it'
import Prism from 'prismjs'
import 'prism-languages'

import 'prismjs/themes/prism-okaidia.min.css'
import 'prismjs/plugins/line-numbers/prism-line-numbers.min.js'
import 'prismjs/plugins/line-numbers/prism-line-numbers.min.css'

export default {
  html: true,
  breaks: true,
  langPrefix: 'language-',
  linkify: false,
  highlight: (str, lang) => {
    if (lang) {
      const langObject = Prism.languages[lang]
      try {
        return (
`<pre class="line-numbers">
  <code class="language-${lang}">${Prism.highlight(str, langObject, lang)}</code>
</pre>`)
      } catch (_) {
        // 何もしない
      }
    }
    const m = new MarkdownIt()
    return (
      `<pre class="language-${lang}"><code>` +
      m.utils.escapeHtml(str) +
      '</code></pre>'
    )
  }
}
